import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { useNavigate } from 'react-router-dom';
import {
  submitSurveyAction,
  clearSurveyAction
} from '../../../actions';
import { AVAILABLE_LANGUAGES, DEGREE_PROGRAM_NOT_SELECTED, routes } from '../../../constants';
import { surveyTypeValues } from '../../../constants/types';
import styles from './submitSurvey.module.css';
import { getTranslation } from '../../../i18n';
import { isSurveyForDegreeProgram } from '../../../util';

const SubmitSurvey = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { surveyOptions: survey } = useSelector((state) => state.survey);
  const { surveyType } = survey;

  const dispatchSubmit = (surveyOptions) => (
    dispatch(submitSurveyAction(surveyOptions))
  );

  const dispatchClear = () => {
    dispatch(clearSurveyAction());
  };

  const afterSubmit = () => {
    navigate(routes.surveySubmitted);
    dispatchClear();
  };

  const submit = () => {
    let { title, researchConsentNeeded } = survey;
    const degreeProgramName = survey.degreeProgram?.name;
    if (isSurveyForDegreeProgram(surveyType)) {
      title = AVAILABLE_LANGUAGES.reduce(
        (titles, lang) => {
          const schemaTitleTranslation = getTranslation(survey.schemaTitle, lang);
          const degreeProgramNameTranslation =
            degreeProgramName && Object.keys(degreeProgramName).length
              ? getTranslation(degreeProgramName, lang)
              : '';
          const titlePeriodTranslation = getTranslation(survey.titlePeriods[survey.selectedTitlePeriod], lang);
          return Object.assign(
            titles,
            { [lang]: `${schemaTitleTranslation} ${degreeProgramNameTranslation} ${titlePeriodTranslation} ${survey.titleExtraPart}`.replace(/\s\s+/g, ' ').trim() }
          );
        },
        {}
      );
    }
    if (surveyType === surveyTypeValues.COURSE_SURVEY) {
      researchConsentNeeded = false;
    }

    // 'NOT_SELECTED' placeholder is only used for frontend purposes, the backend is fine with null
    const cleanedDegreeProgram = survey.degreeProgram?.code === DEGREE_PROGRAM_NOT_SELECTED.code
      ? null
      : survey.degreeProgram;

    const submitData = {
      ...survey,
      degreeProgram: cleanedDegreeProgram,
      extraSurveyPartId: survey.extraSurveyPart ? survey.extraSurveyPart.id : null,
      title,
      researchConsentNeeded
    };
    dispatchSubmit(submitData)
      .then(afterSubmit);
  };

  return (
    <button
      type="button"
      data-cy="submit-survey-button"
      className={`${styles.submitButton} button`}
      onClick={submit}
    >
      <Translate id="common.save" />
    </button>
  );
};

export default SubmitSurvey;
